import React, { useState, useMemo, useCallback, useEffect } from "react";
import ReactFlow, {
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  Handle,
} from "reactflow";
import "reactflow/dist/style.css";
import { Power, PowerOff } from "lucide-react";
import CustomThemeDrawer from "../../../../../Elements/CustomThemeDrawer";
import { useDispatch, useSelector } from "react-redux";
import {
  setNodesState,
  setEdgesState,
} from "../../../../../../Store/Reducers/SLDSlice";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { Button, Input, Select, Collapse, Space, Divider } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { EditOutlined } from "@ant-design/icons";


const PowerNode = ({ data, id, onUpdate, onDelete }) => {
  console.log(data)
  console.log("PowerNode props:", { onUpdate, onDelete });

  const { title, equipmentType, parameters, status, power = 0,
    current = 0,
    voltage = 0, } = data;
  const color =
    status === "ON" ? "#16a34a" : status === "OFF" ? "#dc2626" : "#f97316";
  const paramValues = {
    power: power,
    current: current,
    voltage: voltage,
  };
  console.log(parameters)
  return (
    <div
      style={{
        pointerEvents: "all",
        zIndex: 10,
      }}
      className="rounded-xl shadow-lg border w-64 text-center overflow-hidden select-none bg-white"
    >
      <div
        className="flex justify-between items-center py-1 px-3"
        style={{ backgroundColor: color }}
      >
        <div className="flex items-center gap-2 text-white">
          {status === "ON" ? <Power size={18} /> :status === "OFF" ? <PowerOff size={18} />:<></>}
          <span className="font-semibold text-sm">{status?.toUpperCase()}</span>
        </div>
          {
            data?.title!="MasterNode"&&(
        <div className="flex gap-2" style={{ pointerEvents: "auto" }}>
          <span
            onClick={(e) => {
              e.stopPropagation();
              console.log("Edit clicked", id);
              onUpdate?.(id, data);
            }}
            className="cursor-pointer"
          >
            <EditOutlined style={{ color: "#fff" }} />
          </span>
          <span
            onClick={(e) => {
              e.stopPropagation();
              console.log("Delete clicked", id);
              onDelete?.(id, data);
            }}
            className="cursor-pointer"
          >
            <DeleteOutlined style={{ color: "#fff" }} />
          </span>
        </div>
            )
          }
      </div>

      <div className="p-3">
        <div className="font-semibold text-gray-800 text-base">{title}</div>
        <div className="text-sm text-gray-500 mb-2">{equipmentType}</div>
      </div>
        <div className="space-y-1 text-gray-700 mb-4">
          {parameters.length === 0 ? (
            <div className="italic text-gray-400 text-sm">
              {/* No parameters selected */}
            </div>
          ) : (
            parameters.map((param) => (
              <div key={param} className="font-semibold text-sm">
                {param.toUpperCase()}:{" "}
                <span className="font-bold">
                  {paramValues[param] !== undefined ? paramValues[param] : "—"}
                </span>
              </div>
            ))
          )}
        </div>

      <Handle type="source" position="bottom" style={{ background: color }} />
      <Handle type="target" position="top" style={{ background: color }} />
    </div>
  );
};




export default function PowerFlowSLD() {
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [selectedConverterID, setSelectedConverterID] = useState();
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges] = useEdgesState([]);
  const [open, setOpen] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [nodeType, setNodeType] = useState([]);
  const [equipment, setEquipment] = useState([]);
  const [sldDetails, setSldDetails] = useState([]);
  const [parameter, setParameter] = useState([]);
  const [sldData, SetSldData] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [metersData, setMetersData] = useState([]);
  const [selectedMeterIds, setSelectedMeterIds] = useState();
  const [refetch,setRefetch]=useState(false)
  const[update,setUpdate]=useState(false)
  const mode = useSelector((state) => state.darkMode);
  const[sldNodeMeterID,setSldNodeMeterID]=useState(null)
  //console.log(color);
  const { isdarkMode } = mode;
  const [newNode, setNewNode] = useState({
    title: "",
    converterID: "",
    meterID: "",
    type: "",
    parameters: [],
    parent: "",
    status: null,
    operation: "",
  });



const handleUpdate = useCallback(
  (id, data) => {
    console.log("Updating node", id, data);

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_NODE_METER_DEATILS}?NodeID=${id}`,
    }).then((res) => { 
      console.log("Fetched meter details:", res);
      setSldNodeMeterID(res)
      if (res && Array.isArray(res) && res.length > 0) {
        const first = res[0];

        //  Find matching equipment by name
        const matchedEquipment = equipment.find(
          (eq) => eq.equipmentTypeName === first.label
        );
        console.log(matchedEquipment)

        setNewNode({
          id, // for update
          title: first.nodeName || "",
          parent: first.parentNodeID || "",
          type: matchedEquipment?.value || null, // store id directly
          meters: res.map((item) => { 
            //  Split parameter names and find matching ids
            const paramList = item.parameterNames
              ? item.parameterNames.split(",").map((p) => p.trim())
              : [];

            const matchedParams = parameter
              .filter((param) => paramList.includes(param.label))
              .map((p) => ({
                label: p.label,
                value: p.value,
              }));
              console.log(matchedParams)
              console.log(matchedParams.map((i)=>i.value).join(","))

            return {
              id: item.sldNodeMeterID,
              converter: {
                label: item.sitename,
                value: item.sitename,
                key: item.siteid,
              },
              meter: {
                label: item.metername,
                value: item.metername,
                key: item.meterid,
              },
              operation: item.operation || "Plus",
              parameters: matchedParams.map((i)=>i.value), 
              sldNodeMeterID:item.sldNodeMeterID
            };
          }),
        });

        setOpen(true);
        setShowDrawer(true);
      }
    });
  },
  []
);


const handleUpdateSubmit = () => {
  if (!newNode.id) return; // only for update

  console.log(newNode)
  const body = newNode.meters.map((m) => ({
    converterID: m.converter?.key,
    sldNodeMeterID:m.sldNodeMeterID,
    meterID: m.meter?.key,
    parameterID: m.parameters.join(","),
    operation: m.operation,
  }));

  makeRequest({
    type: APIConstants.PUT, // or POST, depending on your API
    url: `${APIConstants.UPDATE_SLD_DATA}?NodeID=${newNode.id}&EquipmentTypeID=${newNode.type}&NodeName=${newNode.title}`,
    body,
  }).then((res) => {
    console.log("Update response:", res);
    setRefetch((prev) => !prev);
    setShowDrawer(false);
    setOpen(false);
    setNewNode({
      title: "",
      converterID: "",
      meterID: "",
      type: "",
      parameters: [],
      parent: "",
      status: null,
      operation: "",
    });
  });
};

const handleDelete = useCallback((id, data) => {
  console.log("Deleting node", id);
    console.log("Delete Node Data:", data );
      makeRequest({
      type: APIConstants.DELETE,
      url: `${APIConstants.DELETE_SLD_DATA}?ParentNodeID=${id}`,
    }).then((res) => {
      console.log(res.message);
      setRefetch(!refetch)
    });
}, []);

const nodeTypes = useMemo(
  () => ({
    powerNode: (props) => (
      <PowerNode {...props} onUpdate={handleUpdate} onDelete={handleDelete} />
    ),
  }),
  [handleUpdate, handleDelete]
);




  const handleAddNode = useCallback(() => {
    const id = `${newNode.title.toLowerCase().replace(/\s+/g, "-")}-${Date.now()}`;
    console.log(id);
    console.log(newNode);
    // setUpdate(!update)

  //   {
  //   title: '2',
  //   type: 2,
  //   parameters: [],
  //   parent: 1,
  //   status: null,
  //   operation: '',
  //   meters: [
  //     {
  //       id: 1761714415571,
  //       converter: {
  //         label: 'MinnotraCN1',
  //         value: 'MinnotraCN1',
  //         key: '1',
  //         disabled: undefined,
  //         title: undefined
  //       },
  //       meter: {
  //         label: '8 Way MCB',
  //         value: '8 Way MCB',
  //         key: '11',
  //         disabled: undefined,
  //         title: undefined
  //       },
  //       operation: '+',
  //       parameters: [ 8, 12, 15 ]
  //     }
  //   ]
  // }
    const body=newNode?.meters?.map((i)=>{
      return {
        converterID: i.converter.key,
     meterID: i.meter.key,
     parameterID: i.parameters.join(","),
     operation: i.operation
      }
    }) 

    console.log(body)
      makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.INSERT_SLD_DATA}?nodeName=${newNode.title}&equipmentTypeID=${newNode.type}&parentNodeID=${newNode.parent}`,
      body:body
    }).then((res) => {
      console.log(res); 
      setRefetch(!refetch)
    });
    const node = {
      id,
      type: "powerNode",
      position: { x: 0, y: 0 }, // position will be calculated
      data: {
        title: newNode.title,
        type: newNode.type,
        parameters: newNode.parameters,
        parent: newNode.parent,
        status: newNode.status,
      },
      draggable: false,
    };

    // // Add node & rebuild layout
    // const updatedNodes = [...nodes, node];
    // const arrangedNodes = layoutNodes(updatedNodes);
    // setNodes(arrangedNodes);
    // setEdges(buildEdges(arrangedNodes));

    setShowDrawer(false);
    setOpen(false);
    setNewNode({
      title: "",
      type: "",
      parameters: [],
      parent: "",
      status: null,
      operation: "",
    });
  }, [newNode, nodes]);

  const onClose = () => {
    setOpen(false);
    setShowDrawer(false);
     setNewNode({
      title: "",
      type: "",
      parameters: [],
      parent: "",
      status: null,
      operation: "",
    });
  };

  const nonDraggableNodes = useMemo(
    () => nodes.map((n) => ({ ...n, draggable: false })),
    [nodes]
  );
  const dispatch = useDispatch();

  useEffect(() => {
    // Convert to plain JSON data safely
    const safeNodes = JSON.parse(JSON.stringify(nodes));
    const safeEdges = JSON.parse(JSON.stringify(edges));

    dispatch(setNodesState(safeNodes));
    dispatch(setEdgesState(safeEdges));
    
  }, [nodes, edges, dispatch]);

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_EQUIPMENT_DETAILS}`,
    }).then((res) => {
      console.log(res);
      if (res) {
        const data = res.map((i) => ({
          value: i.equipmentTypeID,
          label: i.equipmentTypeName,
        }));
        setEquipment(data); 
        console.log(data);
      }
    });
    // makeRequest({
    //   type: APIConstants.GET,
    //   url: `${APIConstants.GET_NODE_DETAILS}`,
    // }).then((res) => {
    //   console.log(res);
    //   if (res) {
    //     const data = res.map((i) => ({
    //       value: i.nodeType,
    //       label: i.nodeType,
    //     }));
    //     setNodeType(data);
    //     console.log(data);
    //   }
    // });

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_PARAMETER_TYPE}`,
    }).then((res) => {
      console.log(res);
      if (res) {
        const data = res.map((i) => ({
          value: i.sldParameteID,
          label: i.sldParameterName,
        }));
        console.log(data);
        setParameter(data);
      }
    });

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_MASTER_SLD_DETAILS}`,
    }).then((res) => {
      console.log(res);
      if (res) {
        const data = res.map((i) => ({
          value: i.sldMasterNodeID,
          label: i.nodeName,
        }));
        console.log(data);
        setSldDetails(data);
      }
    });
  }, [open,update]);


const transformSLDData = (apiData) => {
  if (!Array.isArray(apiData) || apiData.length === 0)
    return { nodes: [], edges: [] };

  const grouped = {};

  for (const item of apiData) {
    const nodeKey = String(item.nodeID);
    const operation = (item.operation || "").toLowerCase();
    const sign = operation.includes("minus") || operation.includes("-") ? -1 : 1;

    const params = item.parameterNames
      ? item.parameterNames.split(",").map((p) => p.trim().toLowerCase())
      : [];

    // initialize group if not exists
    if (!grouped[nodeKey]) {
      grouped[nodeKey] = {
        ...item,
        power: 0,
        current: 0,
        voltage: 0,
        hasPowerSource: false,
        parameterNames: "",
      };
    }

    // --- 🧩 If this record includes "power", mark as power source ---
    if (params.includes("power")) {
      grouped[nodeKey].hasPowerSource = true;
      grouped[nodeKey].power = (item.power ?? 0) * sign; // take only from this object
    }

    // --- ⚙️ Handle current and voltage (always additive/subtractive) ---
    if (params.includes("current"))
      grouped[nodeKey].current += (item.current ?? 0) * sign;
    if (params.includes("voltage"))
      grouped[nodeKey].voltage += (item.voltage ?? 0) * sign;

    // --- Merge unique parameter names ---
    const oldParams = grouped[nodeKey].parameterNames
      ? grouped[nodeKey].parameterNames.split(",").map((p) => p.trim())
      : [];
    grouped[nodeKey].parameterNames = [...new Set([...oldParams, ...params])].join(",");

    // --- Fill missing meta fields ---
    grouped[nodeKey].nodeName ||= item.nodeName;
    grouped[nodeKey].equipmentType ||= item.equipmentType;
    grouped[nodeKey].meterStatus ||= item.meterStatus;
    grouped[nodeKey].operation ||= item.operation;
  }

  // convert grouped object to array
  const mergedData = Object.values(grouped);

  // --- 🧮 Build nodes ---
  const nodes = mergedData.map((item) => ({
    id: String(item.nodeID),
    data: {
      title: item.nodeName || "Unnamed Node",
      type: item.parentNodeID === 0 ? "rootNode" : "meterNode",
      parameters: item.parameterNames
        ? item.parameterNames.split(",").map((p) => p.trim())
        : [],
      status: item.meterStatus || "",
      operation: item.operation || "",
      power: item.power ?? 0,
      current: item.current ?? 0,
      voltage: item.voltage ?? 0,
      siteid: item.siteid ?? 0,
      parent: String(item.parentNodeID ?? 0),
      equipmentType: item.equipmentType || null,
    },
    type: "powerNode",
    position: { x: 0, y: 0 },
    draggable: false,
  }));

// --- 🔗 Build edges ---
const edges = mergedData
  .filter((item) => item.nodeID !== 0)
  .map((item, index) => {
    const isChildOn = item.meterStatus === "ON";

    return {
      id: `edge-${item.parentNodeID}-${item.nodeID}-${index}`,
      source: item.parentNodeID === 0 ? "0" : String(item.parentNodeID),
      target: String(item.nodeID),
      type: "smoothstep",
      animated: isChildOn, //  moving animation when child is ON
      style: {
        stroke: isChildOn ? "#16a34a" : "#999", // green for ON edges
        strokeWidth: isChildOn ? 3 : 2,
      },
    };
  });

  // ---  Ensure root node exists ---
  const hasRoot = nodes.some((n) => n.id === "0");
  if (!hasRoot) {
    nodes.unshift({
      id: "0",
      data: { title: "MasterNode", type: "rootNode" },
      type: "powerNode",
      position: { x: 0, y: 0 },
      draggable: false,
    });
  }

  return { nodes, edges };
};





// Layout function
const layoutNodes = (nodes) => {
  const ROOT_Y = 0;
  const LEVEL_HEIGHT = 250;
  const NODE_WIDTH = 200;

  // Build parent → children map
  const childrenMap = {};
  nodes.forEach((n) => {
    const parent = n.data?.parent || "0";
    if (!childrenMap[parent]) childrenMap[parent] = [];
    if (n.id !== parent) childrenMap[parent].push(n.id);
  });

  const roots = nodes.filter((n) => n.data?.parent === "0");
  const visited = new Set();

  const layoutRecursive = (nodeId, depth = 0, xOffset = 0) => {
    if (visited.has(nodeId)) return { width: NODE_WIDTH, positions: [] };
    visited.add(nodeId);

    const node = nodes.find((n) => n.id === nodeId);
    if (!node) return { width: NODE_WIDTH, positions: [] };

    const children = childrenMap[nodeId] || [];
    let totalWidth = 0;
    let childPositions = [];

    children.forEach((childId) => {
      const { width, positions } = layoutRecursive(
        childId,
        depth + 1,
        xOffset + totalWidth
      );
      totalWidth += width + NODE_WIDTH;
      childPositions.push(...positions);
    });

    if (children.length === 0) totalWidth = NODE_WIDTH;

    const nodeX = xOffset + totalWidth / 2 - NODE_WIDTH / 2;
    const nodeY = ROOT_Y + depth * LEVEL_HEIGHT;
    node.position = { x: nodeX, y: nodeY };

    return { width: totalWidth, positions: [node, ...childPositions] };
  };

  let positioned = [];
  let xOffset = 0;

  roots.forEach((r) => {
    const { width, positions } = layoutRecursive(r.id, 0, xOffset);
    xOffset += width + NODE_WIDTH * 1.5;
    positioned = positioned.concat(positions);
  });

  return positioned;
};




  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_SLD_DATA}?FromDate=2025-10-30%2015%3A00%3A17&Todate=2025-10-30%2015%3A14%3A17`,
    }).then((res) => {
      if (res && Array.isArray(res)) {
        console.log("SLD API Data:", res);

        // Transform API data into nodes and edges
        const { nodes: apiNodes, edges: apiEdges } = transformSLDData(res);
        console.log(transformSLDData(res)) 

        // Layout calculation (reuse your layoutNodes)
        const arrangedNodes = layoutNodes(apiNodes);

        setNodes(arrangedNodes);
        setEdges(apiEdges);

        // Save to Redux
        // dispatch(setNodesState(arrangedNodes));
        // dispatch(setEdgesState(apiEdges));
      }
    });
  }, [refetch]);
  const [errors, setErrors] = useState({});

  const validateFields = () => {
    const newErrors = {};

    if (!newNode.title) newErrors.title = "Node Title is required.";
    if (!newNode.parent) newErrors.parent = "Parent Node is required.";
    if (!newNode.type) newErrors.type = "Equipment Type is required.";

    if (!newNode.meters?.length) {
      newErrors.meters = "Please add at least one Meter.";
    } else {
      newErrors.meters = newNode.meters.map((m) => {
        const meterErrors = {};
        if (!m.converter) meterErrors.converter = "Converter Type is required.";
        if (!m.meter) meterErrors.meter = "Meter Type is required.";
        if (!m.operation) meterErrors.operation = "Operation is required.";
        if (!m.parameters?.length)
          meterErrors.parameters = "Select at least one Parameter.";
        return meterErrors;
      });
    }

    setErrors(newErrors);
    // If any field invalid, return false
    return (
      Object.keys(newErrors).length === 0 ||
      (Object.keys(newErrors).length === 1 &&
        newErrors.meters?.every((m) => Object.keys(m).length === 0))
    );
  };

  const handleSubmit = () => {
    if (!validateFields()) return; // Stop if invalid
    handleAddNode(); // Proceed normally
  };

  const handleConverter = (value) => {
    console.log(value);
    //  setNewNode({ ...newNode, meterID: '' })
    setSelectedMeterIds(null);
    setSelectedConverterID(value?.key);
  };

  // Meters
  useEffect(() => {
    if (selectedConverterID) {
      makeRequest({
        type: APIConstants.GET,
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${selectedConverterID}`,
      }).then((res) => {
        //console.log(res);
        if (res && res.length > 0) {
          setMetersData(res);
        } else {
          setMetersData([]);
        }
      });
    }
  }, [selectedConverterID]);
  // converters
  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS}`,
    }).then((res) => {
      console.log(res);
      if (res && res.length > 0) {
        setGroupData(res);
      }
    });
  }, []);
  return (
    <div style={{ width: "100%", height: "90vh", position: "relative" }}>
      <CustomThemeDrawer
        width={newNode.meters?.length > 0 ? 1000 : 500}
        title={newNode.id ? "Edit Node" : "Add Node"}
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col gap-4 mt-2">
          <div>
            <label className="block mb-1 font-medium">Node Title</label>
            <Input
              placeholder="Enter node title"
              value={newNode.title}
              onChange={(e) =>
                setNewNode({ ...newNode, title: e.target.value })
              }
            />
            {errors.title && (
              <p className="text-red-500 text-xs mt-1">{errors.title}</p>
            )}
          </div>

          <div>
            <label className="block mb-1 font-medium">Parent Node</label>
            <Select
              className="w-full"
              placeholder="Select parent node"
              value={newNode.parent || undefined}
              onChange={(value) => setNewNode({ ...newNode, parent: value })}
              options={sldDetails}
            />
            {errors.parent && (
              <p className="text-red-500 text-xs mt-1">{errors.parent}</p>
            )}
          </div>

          <div>
            <label className="block mb-1 font-medium">Equipment Type</label>
            <Select
              className="w-full"
              placeholder="Select equipment type"
              value={newNode.type || undefined}
              onChange={(value) => setNewNode({ ...newNode, type: value })}
              options={equipment}
            />
            {errors.type && (
              <p className="text-red-500 text-xs mt-1">{errors.type}</p>
            )}
          </div>

          <div>
            <div className="flex justify-between items-center mb-2">
              <h3 className="font-semibold text-lg">Meters</h3>
              <Button
                type="primary"
                onClick={() => {
                  const newMeter = {
                    id: Date.now(),
                    converter: "",
                    meter: "",
                    operation: "",
                    parameters: [],
                  };
                  setNewNode({
                    ...newNode,
                    meters: [...(newNode.meters || []), newMeter],
                  });
                }}
              >
                + Add Meters
              </Button>
            </div>

            {newNode.meters?.length ? (
              <Collapse accordion>
                {newNode.meters.map((meterItem, index) => (
                  <Collapse.Panel
                    key={meterItem.id}
                    header={`Meter ${index + 1}`}
                    extra={
                      <Button
                        size="small"
                        type="text"
                        danger
                        onClick={(e) => {
                          e.stopPropagation();
                          setNewNode({
                            ...newNode,
                            meters: newNode.meters.filter(
                              (m) => m.id !== meterItem.id
                            ),
                          });
                        }}
                      >
                        Delete
                      </Button>
                    }
                  >
                    {/* Make all four fields appear in a single row */}
                    <div className="flex flex-wrap gap-4 mt-2">
                      {/* Converter Type */}
                      <div className="flex-1 min-w-[180px]">
                        <label className="block mb-1 font-medium">
                          Converter Type
                        </label>
                        <Select
                          labelInValue
                          className="w-full"
                          placeholder="Select converter"
                          value={meterItem.converter || undefined}
                          onChange={(value) => {
                            const updated = newNode.meters.map((m) =>
                              m.id === meterItem.id
                                ? { ...m, converter: value, meter: "" } // reset meter
                                : m
                            );
                            handleConverter(value);
                            setNewNode({ ...newNode, meters: updated });
                          }}
                        >
                          {groupData.map((i) => (
                            <Option key={i.siteID} value={i.siteName}>
                              {i.siteName}
                            </Option>
                          ))}
                        </Select>
                        {errors.meters?.[index]?.converter && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.meters[index].converter}
                          </p>
                        )}
                      </div>

                      {/* Meter Type */}
                      <div className="flex-1 min-w-[180px]">
                        <label className="block mb-1 font-medium">
                          Meter Type
                        </label>
                        <Select
                          placeholder="Select meter"
                          value={meterItem.meter || undefined}
                          onChange={(value) => {
                            const updated = newNode.meters.map((m) =>
                              m.id === meterItem.id ? { ...m, meter: value } : m
                            );
                            setNewNode({ ...newNode, meters: updated });
                          }}
                          labelInValue
                          dropdownClassName={
                            isdarkMode
                              ? "select-dropdown-background"
                              : "light-mode-dropdown"
                          }
                          className={`${
                            isdarkMode
                              ? "custom-select-dark select-dropdown-background"
                              : "custom-select-light"
                          } w-full`}
                        >
                          {metersData.map((i) => (
                            <Option key={i.meterid} value={i.metername}>
                              {i.metername}
                            </Option>
                          ))}
                        </Select>
                        {errors.meters?.[index]?.meter && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.meters[index].meter}
                          </p>
                        )}
                      </div>

                      {/* Operation */}
                      <div className="flex-1 min-w-[180px]">
                        <label className="block mb-1 font-medium">
                          Operation
                        </label>
                        <Select
                          className="w-full"
                          placeholder="Select operation"
                          value={meterItem.operation || undefined}
                          onChange={(value) => {
                            const updated = newNode.meters.map((m) =>
                              m.id === meterItem.id
                                ? { ...m, operation: value }
                                : m
                            );
                            setNewNode({ ...newNode, meters: updated });
                          }}
                          options={[
                            { label: "Plus", value: "Plus" },
                            { label: "Minus", value: "Minus" },
                          ]}
                        />
                        {errors.meters?.[index]?.operation && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.meters[index].operation}
                          </p>
                        )}
                      </div>

                      {/* Parameters */}
                      <div className="flex-1 min-w-[180px]">
                        <label className="block mb-1 font-medium">
                          Parameters
                        </label>
                        <Select
                          className="w-full"
                          mode="multiple"
                          placeholder="Select parameters"
                          value={meterItem.parameters || undefined}
                          onChange={(value) => {
                            const updated = newNode.meters.map((m) =>
                              m.id === meterItem.id
                                ? { ...m, parameters: value }
                                : m
                            );
                            setNewNode({ ...newNode, meters: updated });
                          }}
                          options={parameter}
                        />
                        {errors.meters?.[index]?.parameters && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.meters[index].parameters}
                          </p>
                        )}
                      </div>
                    </div>
                  </Collapse.Panel>
                ))}
              </Collapse>
            ) : (
              <div className="text-gray-400 italic text-sm">
                No meters added. Click “+ Add Meters”.
              </div>
            )}
            {errors.meters && typeof errors.meters === "string" && (
              <p className="text-red-500 text-xs mt-1">{errors.meters}</p>
            )}
          </div>

         <Button
  type="primary"
  onClick={() => {
    if (newNode.id) {
      handleUpdateSubmit(); // update existing
    } else {
      handleSubmit(); // add new
    }
  }}
>
  {newNode.id ? "Update Node" : "Add Node"}
</Button>

        </div>
      </CustomThemeDrawer>

      <ReactFlow
        nodes={nonDraggableNodes}
        edges={edges}
        nodeTypes={nodeTypes}
        onNodesChange={onNodesChange}
        fitView
        nodesDraggable={false}
        defaultViewport={{ x: 100, y: 100, zoom: 1 }}
        snapToGrid={true}
        snapGrid={[40, 40]} // ensures 40px spacing grid
        nodeOrigin={[0.2, 0]}
      >
        <MiniMap
          nodeColor={(n) =>
            n.data?.status === "on"
              ? "#16a34a"
              : n.data?.status === "off"
                ? "#dc2626"
                : "#f97316"
          }
        />
        <Controls showInteractive={false} />
        <Background color="#e2e8f0" gap={16} />
      </ReactFlow>

      <Button
        type="primary"
        shape="round"
        size="large"
        style={{
          position: "absolute",
          bottom: 20,
          right: 30,
          boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
        }}
        onClick={() => {
          setOpen(true);
          setShowDrawer(true);
        }}
      >
        + Add Node
      </Button>
    </div>
  );
}
